import React from 'react';
import styled from 'styled-components';

import { IFrame } from './i-frame';
import { LinkActions } from './link-actions';
import { LinkGenerator } from './link-generator';

const AccessTokens = () => {
  const [accessTokenUrl, setAccessTokenUrl] = React.useState<string>();
  const [iframeUrl, setIframeUrl] = React.useState<string>();

  return (
    <Component>
      <HorizontalFlexContainer>
        <MenuContainer>
          <LinkGenerator
            onLinkCreated={(url) => setAccessTokenUrl(url)}
            onLinkDeleted={() => {
              setAccessTokenUrl(undefined);
              setIframeUrl(undefined);
            }}
          />
          <LinkActions url={accessTokenUrl} onUrlOpenClicked={(url) => setIframeUrl(url)} />
        </MenuContainer>
        <IFrame url={iframeUrl} />
      </HorizontalFlexContainer>
    </Component>
  );
};

AccessTokens.propTypes = {};

const FlexContainer = styled.div`
  display: flex;
  gap: 20px;
  height: 100%;
`;

const Component = styled(FlexContainer)`
  flex-direction: column;
  height: 65vh;
`;

const HorizontalFlexContainer = styled(FlexContainer)`
  flex-direction: row;
`;

const MenuContainer = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  width: 300px;
`;

export { AccessTokens };
